import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.syncTimezone()
  }

  syncTimezone() {
    const TIMEZONE_ALIASES = {
      'Asia/Calcutta': 'Asia/Kolkata',
      'US/Eastern': 'America/New_York',
      'US/Central': 'America/Chicago',
      'US/Mountain': 'America/Denver',
      'US/Pacific': 'America/Los_Angeles',
      // Add more as needed
    }
    let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    timezone = TIMEZONE_ALIASES[timezone] || timezone
    if (this.getCurrentTimezone() !== timezone) {
      this.setTimezone(timezone)
    }
  }

  getCurrentTimezone() {
    return document.cookie.split('; ').find(row => row.startsWith('timezone='))?.split('=')[1]
  }

  setTimezone(timezone) {
    const TIMEZONE_ALIASES = {
      'Asia/Calcutta': 'Asia/Kolkata',
      'US/Eastern': 'America/New_York',
      'US/Central': 'America/Chicago',
      'US/Mountain': 'America/Denver',
      'US/Pacific': 'America/Los_Angeles',
      // Add more as needed
    }
    timezone = TIMEZONE_ALIASES[timezone] || timezone
    document.cookie = `timezone=${timezone}; path=/; SameSite=Lax`
    // Reload the page to apply the new timezone if it changed
    if (this.getCurrentTimezone() !== timezone) {
      window.location.reload()
    }
  }
} 